// Account lock wording (AQUASTAR-540, AQUASTAR-542).
//
// Five wrong passwords lock an account for 30 minutes. The sign-in response
// is 401 { code: 'ACCOUNT_LOCKED', message, lockedUntil }; the Users page
// (admin console) gets lockedUntil / lockExpired per row. Resetting the password with
// Forgot Password ends the lock at once, so both say so.

const LEAD = 'This account is locked after too many sign-in attempts.';
export const UNLOCK_NOW = 'To unlock it now, choose Forgot Password and set a new password.';

function when(until: Date, now: Date, locale?: string): string {
  return until.toDateString() === now.toDateString()
    ? until.toLocaleTimeString(locale, { hour: 'numeric', minute: '2-digit' })
    : until.toLocaleString(locale, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}

function parse(iso: string | null | undefined): Date | null {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** Sign-in error text for a locked account, in the viewer's local time. */
export function lockedSignInMessage(
  lockedUntil: string | null | undefined,
  now: Date = new Date(),
  locale?: string,
): string {
  const until = parse(lockedUntil);
  const retry = until && until > now ? `Try again after ${when(until, now, locale)}.` : 'Try again later.';
  return `${LEAD} ${retry} ${UNLOCK_NOW}`;
}
